// extracted by mini-css-extract-plugin
export default {"card":"g3-z"};